export const initCommittee = () => {
  const committeeMembers = document.querySelectorAll(
    ".committee-members .person",
  )

  committeeMembers.forEach((person) => setHeights(person))

  function setHeights(person) {
    person.dataset.width = person.offsetWidth
    person.style.setProperty("--full-height", `${person.offsetHeight}px`)
    const personBody = person.querySelector(".person__body")
    personBody.style.setProperty(
      "--default-height",
      `${personBody.offsetHeight}px`,
    )
  }

  const RO = new ResizeObserver((entries) => {
    return entries.forEach((entry) => {
      const person = entry.target
      const width = parseInt(person.dataset.width, 10)
      if (width !== person.offsetWidth) {
        person.removeAttribute("style")
        setHeights(person)
      }
    })
  })

  window.addEventListener("load", () => {
    committeeMembers.forEach((person) => {
      RO.observe(person)
    })
  })

  window.addEventListener("click", (e) => {
    const person = e.target.closest(".person")
    if (person) {
      person.classList.add("active")
      committeeMembers.forEach((personB) => {
        if (personB != person && personB.classList.contains("active"))
          personB.classList.remove("active")
      })
    }
  })
}
